import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setMediaState as setMediaStateAction } from 'redux/modules/device';
import { MEDIA_QUERY_MAP } from 'constants/media-queries';
import { debounce } from 'helpers/debounce';
import { insertEntry } from 'helpers/object';

const DEBOUNCE_MS = 100;

export const matchMedias = () =>
  Object.entries(MEDIA_QUERY_MAP)
    .map(([breakpoint, query]) => [breakpoint, window.matchMedia(query).matches])
    .reduce(insertEntry, {});

export const mapDispatchToProps = {
  setMediaState: setMediaStateAction,
};

export class MediaListenerUnwrapped extends Component {
  static listener = null;

  componentDidMount() {
    if (__CLIENT__ && !MediaListenerUnwrapped.listener) {
      const listener = () => this.props.setMediaState(matchMedias());
      // Call listener to set state from the window, then attach debounced listener
      listener();
      MediaListenerUnwrapped.listener = debounce(listener, DEBOUNCE_MS);
      window.addEventListener('resize', MediaListenerUnwrapped.listener);
    }
  }

  componentWillUnmount() {
    if (__CLIENT__) {
      window.removeEventListener('resize', MediaListenerUnwrapped.listener);
    }
  }

  render() {
    return null;
  }
}

MediaListenerUnwrapped.propTypes = {
  setMediaState: PropTypes.func.isRequired,
};

export const MediaListener = connect(null, mapDispatchToProps)(MediaListenerUnwrapped);
